module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag31_1549AT.8c95890a.jpg";